import React from 'react';
import { I18n } from '@fiverr-private/fiverr_context';
import Link from '../../../Links/Link';

const AskTheCommunityLink = () => (
    <Link
        href="https://community.fiverr.com/forums/forum/52-fiverr-questions/"
        target="_blank"
        rel="noopener noreferrer"
        className="nav-link"
    >
        <I18n k="header.link_label.ask_the_community" />
    </Link>
);

export default AskTheCommunityLink;
